import { createClient } from '@supabase/supabase-js';

// Initialize a new Supabase client instance
const supabaseUrl = 'https://orxphmulfpkycxtmdost.supabase.co'; // Replace with your Supabase URL
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9yeHBobXVsZnBreWN4dG1kb3N0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTI1NzI0OTksImV4cCI6MjAwODE0ODQ5OX0.jXXc-jmu03XfvyLMRzTkc4-cP2Fq2oiwsFS-UPrEelE'; // Replace with your Supabase anonymous key
const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
